// Browsers fire `beforeinstallprompt` once, often before the pocket card opens, so capture it at startup and share it.
export type InstallPrompt = Event & { prompt: () => Promise<void>; userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }> }

let deferred: InstallPrompt | null = null
let listening = false
const listeners = new Set<(prompt: InstallPrompt | null) => void>()
const publish = (prompt: InstallPrompt | null) => { deferred = prompt; listeners.forEach(listener => listener(prompt)) }

export function captureInstallPrompt() {
  if (listening || typeof window === 'undefined') return
  listening = true
  window.addEventListener('beforeinstallprompt', event => { event.preventDefault(); publish(event as InstallPrompt) })
  window.addEventListener('appinstalled', () => publish(null))
}

export const currentInstallPrompt = () => deferred
export const clearInstallPrompt = () => publish(null)
export function onInstallPrompt(listener: (prompt: InstallPrompt | null) => void) {
  listeners.add(listener)
  return () => { listeners.delete(listener) }
}
